var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSupported)?_c('div',{staticClass:"eye-dropper text-white",on:{"click":_vm.handleOpen}},[_c('icon-drop',{staticClass:"text-18 cursor-pointer"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }